import { render } from "./FormElements.vue?vue&type=template&id=36bd5280"
import script from "./FormElements.vue?vue&type=script&lang=js"
export * from "./FormElements.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__